 
import React from "react";
import HomePage from "../../components/Home";


const GeneralApp = () => {
 
  return (
    <>
  <HomePage/>
  
    </>
  );
};

export default GeneralApp;
